module.exports = __webpack_public_path__ + "static/pension-00b70c0a8a2783a6cebddca596305527.png";